module.exports = __webpack_public_path__ + "img/Wattens1.34fd9ee4.jpg";